import HiddenReadableText from "./hiddenReadableText/index.jsx"

export default {
  HiddenReadableText,
}
